<div [@menuState]="menuState" class="menu_top-items-wrapper">
  <ng-content></ng-content>
  menuState: {{ menuState }}
</div>
